import ResultatPatientModal from '@/views/analyse/registre_analyse/resultat-patient-modal';
import VoirResultat from '@/views/analyse/visualiser-resultat';
import $ from 'jquery';

import DateFilter from '@/components/date-filter';
import store_analyse from '@/store/mods/analyses/analyse';
import GroupedAnalysisResultsPDF from '@/views/analyse/registre_analyse/components/GroupedAnalysisResultsPDF';
import RegistrePatient from '@/views/analyse/registre_analyse/registre-patient';
import ResultatPatient from '@/views/analyse/registre_analyse/resultat-patient';
import EnteteBonEtFacture from '@/views/en-tete-bon-facture';

export default {
    name: 'registre-analyse',
    components: {
        VoirResultat, 
        RegistrePatient, DateFilter, ResultatPatientModal, 
        ResultatPatient, EnteteBonEtFacture, GroupedAnalysisResultsPDF
    },
    props: [],
    data() {
        return {
            isResultsLoading: false,
            is_loading: true,
            is_empty: false,

            liste_analyse_filtre: [],
            fields: [
                'patient', { key: 'age', label: 'Âge' }, 'sexe', 'date', { key: 'statut', label: 'Statut' }, 
                { key: 'action', label: 'Action.s' }
            ],
			filter: [],
			perPage: 25,
			currentPage: 1,

            filtre_resultat: {
                analyse_id: 0,
                analyse: 'Tous'
            },

            result_preview: {},
            results: null,
            selectedPatient: undefined,

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,
            liste_registre_analyse: [],
            can_print: false,
            can_print_grouped: false,
            view_result_loading: false,
            toggler: 0,
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
            }
            this.current_date_filter = data
            this.is_month = true
            this.getRegistreAnalyse(data)
        },

        selectedPatient: function (newVal) {
            if (newVal !== undefined) {
                this.filtre_resultat = undefined
            }
        },
        
        filtre_resultat: function (newVal) {
            if (newVal !== undefined) {
                this.selectedPatient = undefined
            }
        }
    },

    computed: {
        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            var m = []
            for (index = 0; index <= this.current_date.getMonth() + 1; index++) {
                m[index] = this.list_months[index];
            }
            return m;
        },

        showPatientSection() {
            return this.selectedPatient !== undefined && this.filtre_resultat === undefined;
        },

        patients() {
            return this.$store.getters['patients']
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        analyses() {
            return this.$store.getters['analyses']
        },
    },

    mounted() {
        this.curr_month = this.monthOfYear[this.current_date.getMonth()+1]
        this.$store.commit("SET_TSL_FILTER_DATE", {});

        this.$store.dispatch('getPatients')

        this.$store.dispatch('getAnalyses').then((liste_analyses) => {
            this.liste_analyses = liste_analyses
        })
    },

    methods: {
        getRegistreAnalyse(data) {
            this.is_loading = true
            store_analyse.getRegistreAnalyse(data).then((registre) => {
                this.liste_registre_analyse = registre
                if (this.liste_registre_analyse.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
    
                let select_all = {
                    analyse_id: 0,
                    analyse: 'Tous'
                }
                this.liste_analyse_filtre.push(select_all)
    
                this.liste_registre_analyse.forEach(element => {
                    let t = {
                        analyse_id: element['analyse_id'],
                        analyse: element['analyse']
                    }
                    this.liste_analyse_filtre.push(t)
                });
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.getRegistreAnalyse(data)
        },

        onFilterTarif() {
			let id_selected = this.filtre_resultat?.analyse_id

			if (id_selected > 0) {
                $('.shw-result').fadeOut(500)
				setTimeout(() => {
					$('.result-anl-'+id_selected).fadeIn()
				}, 500);
			} else {
				$('.shw-result').fadeIn(500)
			}
		},

        async previewResultExamen(demande_analyse, item) {
            this.view_result_loading = true
            
            if (this.is_modele_analyse) {
                if (item.etat_resultat == 1 && item.resultat == null) {
                    $("#view-analysis-modal").modal('show');

                    // const param = {
                    //     analyseId: demande_analyse.analyse_id,
                    //     bulletinId: item.bulletin_id
                    // }
                    const demande_analyse_id = item.demande_id
                    this.$store.dispatch("getResultsByAnalyseIdBulletinId", { demande_analyse_id }).then((response) => {
                        this.results = response.data;
                        this.view_result_loading = false
                    })
                } else {
                    const demande = {
                        analyse_nom: demande_analyse.analyse,
                        resultat_fichier: item.resultat,
                        commentaires: item.interpretation
                    }
                    this.toggler = (this.toggler == 0)?1:0
                    this.result_preview = demande

                    $('.visualiser-resultat .modal').modal('show');
                }
            } else {
                const demande = {
                    analyse_nom: demande_analyse.analyse,
                    resultat_fichier: item.resultat,
                    commentaires: item.interpretation
                }
                this.toggler = (this.toggler == 0)?1:0
                this.result_preview = demande

                $('.visualiser-resultat .modal').modal('show');
            }
        },

        getPatientName({ nom, prenoms }) {
            return `${nom} ${prenoms}`;
        },

        redirectTo(analyse_id){
            this.$store.commit("SET_TSL_FILTER_DATE", this.current_date_filter);

            this.$router.push({path:'/analyses/registre-others/'+analyse_id})
        },

        printResultatAnalyse(results) {
            this.results = results
            this.can_print = true
            setTimeout(() => {
                window.print()

                this.can_print = false
            }, 1500);
        },

        printGroupedResult(results) {
            this.results = results
            this.can_print_grouped = true
            setTimeout(() => {
                window.print()

                this.can_print_grouped = false
            }, 1500);
        }
    }
}